import Router from "@/router/index";
import Store from "@/store/index";

export default Router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} - SIS - ${Store.state.tenant.school_name}`;
  next();
});
